import { render } from "./InfoAboutAlarm.vue?vue&type=template&id=5075d0a8&scoped=true&ts=true"
import script from "./InfoAboutAlarm.vue?vue&type=script&lang=ts"
export * from "./InfoAboutAlarm.vue?vue&type=script&lang=ts"

import "./InfoAboutAlarm.vue?vue&type=style&index=0&id=5075d0a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5075d0a8"]])

export default __exports__